export enum RegistrationType {
  INVITATION = "INVITATION",
  LOCKED = "LOCKED",
  OPEN = "OPEN",
}
